import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DateRange, extractDateRange, extractDefaultStoreId, extractNumber, HxReportService, HxUiLabelPipe, toRouterQueryParams } from 'hx-services';
import { Subscription } from 'rxjs';
import { saveAs } from 'file-saver';
import { ErrorHandlerService } from '@manager-app/service/error-handler.service';
import { HcToastrService } from '@manager-app/service/toastr.service';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { HxDateRangeSelectComponent, HxLoaderComponent, HxStoreSelectComponent } from 'hx-component';
import { FormsModule } from '@angular/forms';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { NgbPagination } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-realized-product.m-grid__item.m-grid__item--fluid.m-wrapper',
    templateUrl: './realized-product.component.html',
    styleUrls: ['./realized-product.component.css'],
    imports: [HxStoreSelectComponent, FormsModule, HxDateRangeSelectComponent, NgIf, NgFor, NgClass, HxLoaderComponent, NgbPagination, TranslocoPipe, HxUiLabelPipe]
})
export class RealizedProductComponent implements OnInit, OnDestroy {
  list = [];
  isLoading = {
    list: false,
    generate: false,
  };
  params: {
    storeId?: number,
    date?: DateRange,
    page: number,
    limit: number,
  } = {page: 1, limit: 20};
  pagination = {
    allItemCount: 0
  };
  private sub: Subscription;

  constructor(
    private reportService: HxReportService,
    private aRoute: ActivatedRoute,
    private router: Router,
    private errorService: ErrorHandlerService,
    private toastr: HcToastrService,
    private tr: TranslocoService
  ) {
  }

  ngOnInit() {
    this.sub = this.aRoute.queryParamMap.subscribe(params => {
      this.params.date = extractDateRange('date', params);
      this.params.storeId = extractNumber('storeId', params) ?? extractDefaultStoreId();
      this.params.page = extractNumber('page', params) ?? 1;
      this.params.limit = extractNumber('limit', params) ?? 20;
      if (this.params.storeId) {
        this.loadList();
      }
    });
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  private loadList() {
    this.isLoading.list = true;
    this.list = [];

    this.reportService.getRealizedProduct(this.params).subscribe(response => {
      this.list = response.list || [];
      this.pagination.allItemCount = response.count;
      this.isLoading.list = false;
    }, error => {
      this.isLoading.list = false;
      this.errorService.handler(error);
    });
  }

  generate() {
    this.isLoading.generate = true;
    this.list = [];
    this.reportService.getRealizedProductGenerate(this.params).subscribe(response => {
      const contentDispositionHeader = response.headers.get('Content-Disposition');
      const result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
      const blob = new Blob([response.body], {type: 'application/octet-stream'});
      saveAs(blob, result);
      this.loadList();
      this.toastr.success(this.tr.translate('realized-product.ts.success'));
      this.isLoading.generate = false;
    }, () => this.isLoading.generate = false);
  }

  pageChanged(event: number) {
    this.params.page = event;
    this.navigate();
  }

  navigate() {
    this.router.navigate(['./'], {
      queryParams: toRouterQueryParams(this.params),
      relativeTo: this.aRoute
    });
  }
}
